import React from "react";
import styled from "styled-components";
import {
    MELOGY_BACKGROUND_XDARK_GREY,
    MELOGY_WHITE,
} from "../../style/colors";
import {
    FONT_SIZE_4XS,
    TITLE_FONT_FAMILY,
    TITLE_FONT_WEIGHT,
} from "../../style/fontSettings";

const RotateWarningContainer = styled.div`
    width: 100vw;
    height: calc(var(--vh, 1vh) * 100);
    background-color: ${MELOGY_BACKGROUND_XDARK_GREY};
    color: ${MELOGY_WHITE};
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    overflow: hidden;
    z-index: 9999;
`;

const RotateWarningText = styled.div`
    font-size: ${FONT_SIZE_4XS};
    font-family: ${TITLE_FONT_FAMILY};
    font-weight: ${TITLE_FONT_WEIGHT};
    text-align: center;
    padding: 20px;
`;

const RotateWarning = ({ isPortrait, minimumHeight }) => {
    return (
        <RotateWarningContainer>
            <RotateWarningText>
                {isPortrait
                    ? `Your screen height is too small. Please use a device with a taller screen (minimum ${minimumHeight}px) for the best experience.`
                    : "Please rotate your device to portrait mode for the best experience."}
            </RotateWarningText>
        </RotateWarningContainer>
    );
};

export default RotateWarning; 